import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { apiService } from '../services/api';

const useChallengeStore = create(devtools((set, get) => ({
	challenges: [],
	loading: false,
	error: null,
	lastUpdated: null,

	fetchChallenges: async (force = false) => {
		const state = get();
		const now = Date.now();
		if (!force && state.lastUpdated && (now - state.lastUpdated) < 60000) {
			return;
		}
		set({ loading: true, error: null });
		try {
			const response = await apiService.getChallenges();
			set({
				challenges: response.data || [],
				loading: false,
				lastUpdated: now
			});
		} catch (err) {
			set({
				error: err.message || 'Ошибка при загрузке челенджей',
				loading: false
			});
		}
	},

	reset: () => {
		set({
			challenges: [],
			loading: false,
			error: null,
			lastUpdated: null
		});
	}

}), { name: 'ChallengeStore' }));

export default useChallengeStore; 